export type CardColor = "red" | "blue" | "green" | "yellow" | "wild";

export interface Card {
  color: CardColor;
  value: number | string;
  id: number;
}

export interface HickroGame {
  deck: Card[];
  discard: Card[];
  players: Array<{ hand: Card[]; name: string }>;
  currentPlayer: number;
  direction: 1 | -1;
  topCard: Card | null;
  winner: number | null;
  pendingDraw: number;
  skipped: boolean;
}

export function createDeck(): Card[] {
  const colors: CardColor[] = ["red", "blue", "green", "yellow"];
  const cards: Card[] = [];
  let id = 0;

  for (const color of colors) {
    cards.push({ color, value: 0, id: id++ });
    for (let i = 0; i < 2; i++) {
      for (const v of [1, 2, 3, 4, 5, 6, 7, 8, 9]) {
        cards.push({ color, value: v, id: id++ });
      }
      cards.push({ color, value: "skip", id: id++ });
      cards.push({ color, value: "reverse", id: id++ });
      cards.push({ color, value: "draw2", id: id++ });
    }
  }

  for (let i = 0; i < 4; i++) {
    cards.push({ color: "wild", value: "wild", id: id++ });
    cards.push({ color: "wild", value: "wild4", id: id++ });
  }

  return shuffle(cards);
}

export function shuffle<T>(arr: T[]): T[] {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export function canPlay(card: Card, top: Card): boolean {
  if (card.color === "wild") return true;
  if (top.color === "wild") return true;
  if (card.color === top.color) return true;
  if (card.value === top.value) return true;
  return false;
}
